import {VetineoVisitTypeBundle} from "./vetineo-visit-type-bundle.model";

/**
 * Model reprezentujący główną kategorię usług weterynaryjnych.
 */
export class VetineoVisitTypeCategory {

  /** Wyświetlana nazwa kategorii (Label) gotowa do wyrenderowania w UI. */
  public name: string;

  /** Systemowy kod kategorii (często powiązany z globalnym słownikiem). */
  public code: string;

  /** Zagnieżdżona lista podkategorii przypisanych do tego węzła. */
  public subcategories: VetineoVisitTypeSubCategory[];

  /** Flaga (Toggle) pozwalająca klinice ukryć całą sekcję.
   */
  public enabled?: boolean;

  /** Pozycja na liście (Sort Order) – pozwala wyświetlać najważniejsze działy na samej górze. */
  public orderIdx: number;
}

/**
 * Model reprezentujący podkategorię lub konkretny liść w drzewie usług
 */
export class VetineoVisitTypeSubCategory {

  /** Wyświetlana nazwa podkategorii. */
  public name: string;

  /** Kod systemowy podkategorii. */
  public code: string;

  /** Przełącznik widoczności dla tej konkretnej, mniejszej grupy usług. */
  public enabled?: boolean;

  /** Opcjonalne powiązanie z faktycznym szablonem usługi (Master Bundle).
   * Jeśli to pole jest wypełnione, oznacza to, że dobrnęliśmy do "liścia" w drzewie.
   * Ta podkategoria jest już fizycznie usługą, którą można kliknąć i dodać do koszyka.
   */
  public bundle?: VetineoVisitTypeBundle;

  /** Pozycja podkategorii na liście wewnątrz głównego węzła. */
  public orderIdx: number;

}

/**
 * Płaski model widoku reprezentujący pojedynczy wynik wyszukiwania typu wizyty.
 */
export class VetineoVisitTypeCategorySearchObject {

  /** Nadrzędna kategoria, z której pochodzi znaleziony element. */
  public category: VetineoVisitTypeCategory;

  /** Konkretna podkategoria (usługa), która pasuje do wpisanej frazy. */
  public subcategory: VetineoVisitTypeSubCategory;

}
